import Moment from 'moment';
import STOREFRONT_CODES from '../../constants/storefront-codes';

const intlWeek = [1, 2, 3, 4, 5, 6, 7];
const USWeek = [7, 1, 2, 3, 4, 5, 6];

export const getDayNames = (storefront) => {
  const moment = Moment();
  const isoWeek = storefront === STOREFRONT_CODES.us ||
  storefront === STOREFRONT_CODES.ca ||
  storefront === STOREFRONT_CODES.nl ||
  storefront === STOREFRONT_CODES.eu ||
  storefront === STOREFRONT_CODES.jp ||
  storefront === STOREFRONT_CODES.gb ? USWeek : intlWeek;

  return isoWeek.map(num => moment.isoWeekday(num).format('ddd'));
};
